import { __spreadArray } from "tslib";
export default getConfigFromQueryParams;
function getConfigFromQueryParams(queryParams, paramName) {
    var userConfig = queryParams.get(paramName) || '';
    var y = userConfig.split('_').map(function (x) { return x.split(':'); }).map(function (arr) {
        var _a;
        return (_a = {}, _a[arr[0]] = arr[1], _a);
    });
    return Object.assign.apply(Object, __spreadArray([{}], y, false));
}
// externalAlignments=title:left_description:right_customButton:left_social:left&externalSection=
// &externalSections=Description:top:Title:middle
//
// &externalAlignments=title:left_description:right_customButton:left_social:left&externalSections=Description:top_Title:middle_CustomButton:top_Social:top
//# sourceMappingURL=getConfigFromQueryParams.js.map